
import {  useMutation, useQuery } from "react-query"
import StakeService from "../../../../config/StakeServices"
import DataService from "../../../../config/DataServices"
const { getRequest } = DataService();

const { getStakeRequest , postStakeRequest } = StakeService()

export const useStakeRewardHistory = ({page, size, type ,search}) => {

    return useQuery({
        queryKey: ["stake-reward-history",page,size, type , search],
        queryFn: () => {
            return getStakeRequest(`user/stake/stakeRewardHistory?page=${page}&size=${size}&type=${type}&search=${search}`)
        }
    })
}

export const useICOReferralIncome = ({ page, size,type , search }) => {
    return useQuery({
        queryKey: ["getICOReferralIncome-history", page, size,type, search ],
        queryFn: () => {
            return getStakeRequest(`user/redeem/getICOReferralIncome?page=${page}&size=${size}&type=${type}&search=${search}`)
        }
    })
}


export const useStakedIdRewardHistory = ({ page, size, type , id }) => {

    return useQuery({
        queryKey: ["stakeId-reward-history", page, size, type , id],
        queryFn: () => {
            return getStakeRequest(`user/stake/stakeIdRewardHistory?id=${id}&page=${page}&size=${size}&type=${type}`)
        }
    })
}



export const useDirectRefferals = ({ page, size,searchText }) => {

    return useQuery({
        queryKey: ["direct-refferals-history", page, size,searchText ],
        queryFn: () => {
            return getRequest(`user/auth/directRefferals?page=${page}&size=${size}&search=${searchText}`)
        }
    })
}
export const useMoveToStakeWallet = () => {
    return useMutation({
        mutationFn: data => {
            return postStakeRequest("user/redeem/moveToStake", { ...data })
        },
    })
}

export const useMoveToStakeHistory = ({ page, size, type , search }) => {

    return useQuery({
        queryKey: ["move-to-stake-history", page, size, type , search ],
        queryFn: () => {
            return getStakeRequest(`user/redeem/moveToStakeHistory?page=${page}&size=${size}&type=${type}&search=${search}`)
        }
    })
}

export const useSwapToMasterWallet = () => {

    return useMutation({
        mutationFn: data => {
            return postStakeRequest("user/redeem/swapToMasterWallet", { ...data })
        },
    })
}

export const useSwapVrs = () => {

    return useMutation({
        mutationFn: data => {
            return postStakeRequest("user/redeem/getswabvms", { ...data })
        },
    })
}



export const useUserTotalStake = () => {

    return useQuery({
        queryKey: ["team-stake"],
        queryFn: () => {
            return getStakeRequest(`user/redeem/total-stake`)
        }
    })
}